<template>
  <v-card :loading="loading">
    <v-card-title> Attributs radius </v-card-title>
    <v-card-text>
      <template v-for="attribute in attributes">
        <div :key="attribute['nas'].nasIdentifier">
          <h4 style="text-decoration: underline">
            NAS : {{ attribute["nas"].nasIdentifier }}
          </h4>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Username</th>
                  <th>Attribute</th>
                  <th>Value</th>
                  <th>OP</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="radius in attribute['radius']" :key="radius.id">
                  <td>{{ radius["id"] }}</td>
                  <td>{{ radius["UserName"] }}</td>
                  <td>{{ radius["Attribute"] }}</td>
                  <td>{{ radius["Value"] }}</td>
                  <td>{{ radius["op"] }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
import { useCard } from "@/composables/card";
import { onMounted, toRefs, ref } from "@vue/composition-api";

export default {
  props: {
    cardId: [Number, String],
  },
  setup(props) {
    /* Import des API */
    const { cardData, showCardAttribute } = useCard();

    /* Variables */
    const loading = ref(false);

    /* Cycle de vie */
    onMounted(async () => {
      loading.value = true;
      await showCardAttribute(props.cardId);
      loading.value = false;
    });
    return {
      ...toRefs(cardData),
      loading,
    };
  },
};
</script>
